/* Navimow terms renderer — turns a Shopify page body into the designed terms layout.
   Used by the terms page (sections/navimow-terms.liquid) and the yard-check form dialog, so editing the page updates both.
   Page body format: <div class="terms-th">…</div><div class="terms-en">…</div>, each with paragraphs (intro),
   then one <h2> (or <h3>) per section. A paragraph "เวอร์ชัน 1.0" / "Version 1.0" sets the version in the footer. */
(function () {
  if (window.NavimowTerms) return;
  var T = {
    th: { toc: 'สารบัญ', tocCount: 'สารบัญ {n} ข้อ', sub: 'โปรดอ่านรายละเอียดก่อนส่งแบบประเมิน', privacy: 'ประกาศความเป็นส่วนตัว', version: 'เวอร์ชัน', updated: 'อัปเดตล่าสุด', close: 'ปิด', locale: 'th-TH' },
    en: { toc: 'Contents', tocCount: 'Contents · {n} sections', sub: 'Please read before sending the assessment form', privacy: 'Privacy Notice', version: 'Version', updated: 'Last updated', close: 'Close', locale: 'en-GB' }
  };
  var ICON_X = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var ICON_LIST = '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="4" y="3" width="16" height="18" rx="3" fill="currentColor"/><path d="M8 9h8M8 12.5h8M8 16h8" stroke="#fff" stroke-width="1.8" stroke-linecap="round"/></svg>';
  var ICON_CHEV = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>';
  var ICON_EXT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 4h6v6M20 4l-9 9M18 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5"/></svg>';
  var uid = 0;

  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* Split the body into intro nodes and { title, nodes } sections */
  function parse(src, lang) {
    var part = (src.querySelector && src.querySelector(lang === 'en' ? '.terms-en' : '.terms-th')) || src;
    var work = part.cloneNode(true);
    Array.prototype.forEach.call(work.querySelectorAll('h2,h3'), function (h) { if (/^english$/i.test(h.textContent.trim())) h.remove(); });
    var version = '';
    Array.prototype.some.call(work.querySelectorAll('p'), function (p) {
      var m = p.textContent.trim().match(/^(?:เวอร์ชัน|version)\s*([\w.\-]+)$/i);
      if (m) { version = m[1]; p.remove(); return true; }
    });
    var lvl = work.querySelector(':scope > h2') ? 'H2' : 'H3';
    var intro = [], secs = [], cur = null;
    Array.prototype.slice.call(work.childNodes).forEach(function (n) {
      if (n.nodeType === 1 && n.tagName === lvl) { cur = { title: n.textContent.replace(/^\s*\d+\s*[.)]\s*/, '').trim(), nodes: [] }; secs.push(cur); }
      else if (n.nodeType === 1 || (n.nodeType === 3 && n.textContent.trim())) (cur ? cur.nodes : intro).push(n);
    });
    var priv = work.querySelector('a[href*="privacy"]');
    return { intro: intro, secs: secs, version: version, privacy: priv ? priv.getAttribute('href') : '' };
  }

  function fmtDate(iso, locale) {
    if (!iso) return '';
    var d = new Date(iso);
    if (isNaN(d)) return '';
    try { return d.toLocaleDateString(locale, { day: 'numeric', month: 'short', year: 'numeric' }); } catch (e) { return ''; }
  }

  /* build(source, opts) → element. opts: lang, mode ('modal'|'page'), title, updated (ISO), privacyUrl,
     onClose (adds ✕), onLang (adds TH/EN switch; called with the new lang) */
  function build(src, o) {
    o = o || {};
    var lang = o.lang === 'en' ? 'en' : 'th', t = T[lang], data = parse(src, lang), id = 'ntc' + (++uid);
    var root = el('div', 'ntc ntc--' + (o.mode || 'modal'));
    root.lang = lang;

    if (o.mode !== 'page') root.appendChild(el('div', 'ntc__grab'));
    var head = el('div', 'ntc__head');
    var hgroup = el('div');
    var title = el(o.mode === 'page' ? 'h1' : 'h2', 'ntc__title'); title.id = id + '-title'; title.textContent = o.title || '';
    hgroup.appendChild(title); hgroup.appendChild(el('p', 'ntc__sub', esc(t.sub)));
    head.appendChild(hgroup);
    var tools = el('div', 'ntc__tools');
    if (o.onLang) {
      var sw = el('div', 'ntc__lang'); sw.setAttribute('role', 'group'); sw.setAttribute('aria-label', 'Language');
      [['th', 'TH'], ['en', 'EN']].forEach(function (l) {
        var b = el('button', '', l[1]); b.type = 'button'; b.setAttribute('aria-pressed', String(l[0] === lang));
        b.addEventListener('click', function () { if (l[0] !== lang) o.onLang(l[0]); });
        sw.appendChild(b);
      });
      tools.appendChild(sw);
    }
    if (o.onClose) {
      var x = el('button', 'ntc__close', ICON_X); x.type = 'button'; x.setAttribute('aria-label', t.close);
      x.addEventListener('click', o.onClose); tools.appendChild(x);
    }
    if (tools.childNodes.length) head.appendChild(tools);
    root.appendChild(head);

    var body = el('div', 'ntc__body');
    var toc = el('nav', 'ntc__toc'); toc.setAttribute('aria-label', t.toc);
    toc.appendChild(el('p', 'ntc__toc-title', esc(t.toc)));
    var tog = el('button', 'ntc__toc-toggle', ICON_LIST + '<span>' + esc(t.tocCount.replace('{n}', data.secs.length)) + '</span>' + ICON_CHEV);
    tog.type = 'button'; tog.setAttribute('aria-expanded', 'false'); tog.setAttribute('aria-controls', id + '-toc');
    tog.addEventListener('click', function () { var open = !toc.classList.contains('is-open'); toc.classList.toggle('is-open', open); tog.setAttribute('aria-expanded', String(open)); });
    toc.appendChild(tog);
    var ol = el('ol'); ol.id = id + '-toc'; toc.appendChild(ol);
    var main = el('div', 'ntc__main'); main.tabIndex = -1;
    if (data.intro.length) { var intro = el('div', 'ntc__intro'); data.intro.forEach(function (n) { intro.appendChild(n); }); main.appendChild(intro); }

    var links = [], secEls = [];
    data.secs.forEach(function (s, i) {
      var sid = id + '-s' + (i + 1);
      var sec = el('section', 'ntc__sec'); sec.id = sid; sec.setAttribute('aria-labelledby', sid + '-h');
      sec.appendChild(el('span', 'ntc__num', String(i + 1))).setAttribute('aria-hidden', 'true');
      var wrap = el('div');
      var h = el('h3', 'ntc__sec-title'); h.id = sid + '-h'; h.textContent = s.title; wrap.appendChild(h);
      var sb = el('div', 'ntc__sec-body'); s.nodes.forEach(function (n) { sb.appendChild(n); }); wrap.appendChild(sb);
      sec.appendChild(wrap); main.appendChild(sec); secEls.push(sec);
      var li = el('li'), a = el('a', '', '<span>' + (i + 1) + '.</span><span>' + esc(s.title) + '</span>');
      a.href = '#' + sid; li.appendChild(a); ol.appendChild(li); links.push(a);
    });
    body.appendChild(toc); body.appendChild(main);
    root.appendChild(body);

    var foot = el('div', 'ntc__foot');
    /* Privacy link only when the page body links to a privacy policy (or the host passes one) */
    var privUrl = o.privacyUrl || data.privacy;
    if (privUrl) { var pa = el('a', '', esc(t.privacy) + ICON_EXT); pa.href = privUrl; pa.target = '_blank'; pa.rel = 'noopener'; foot.appendChild(pa); }
    else foot.appendChild(el('span'));
    var meta = [];
    if (data.version) meta.push(t.version + ' ' + data.version);
    var d = fmtDate(o.updated, t.locale); if (d) meta.push(t.updated + ' ' + d);
    if (meta.length) foot.appendChild(el('span', '', esc(meta.join('  |  '))));
    root.appendChild(foot);

    /* TOC: active item follows scroll; clicking scrolls to the section and briefly marks it */
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    function setActive(i) {
      links.forEach(function (a, j) { a.classList.toggle('is-active', j === i); if (j === i) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current'); });
    }
    var lock = 0;
    links.forEach(function (a, i) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var sec = secEls[i];
        if (toc.classList.contains('is-open')) { toc.classList.remove('is-open'); tog.setAttribute('aria-expanded', 'false'); }
        lock = Date.now() + 800; setActive(i);
        sec.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        sec.classList.remove('is-flash'); void sec.offsetWidth; sec.classList.add('is-flash');
        setTimeout(function () { sec.classList.remove('is-flash'); }, 1600);
      });
    });
    if (links.length) setActive(0);
    if ('IntersectionObserver' in window && secEls.length) {
      var seen = {};
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { seen[en.target.id] = en.isIntersecting; });
        if (Date.now() < lock) return;
        for (var i = 0; i < secEls.length; i++) if (seen[secEls[i].id]) { setActive(i); return; }
      }, { root: o.mode === 'page' ? null : main, rootMargin: '0px 0px -55% 0px' });
      secEls.forEach(function (s) { io.observe(s); });
      /* Last section can be too short to reach the top band: activate it at the bottom of the scroll */
      var scroller = o.mode === 'page' ? window : main;
      scroller.addEventListener('scroll', function () {
        if (Date.now() < lock) return;
        var atEnd = o.mode === 'page'
          ? window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 4
          : main.scrollTop + main.clientHeight >= main.scrollHeight - 4;
        if (atEnd) setActive(secEls.length - 1);
      }, { passive: true });
    }
    /* Mobile bottom sheet: drag the handle or header down to close */
    if (o.onClose && o.mode !== 'page') {
      var startY = null, dy = 0, sheet = function () { return root.parentElement; };
      var down = function (e) { if (!matchMedia('(max-width:760px)').matches || e.target.closest('button')) return; startY = e.clientY; dy = 0; if (e.currentTarget.setPointerCapture) e.currentTarget.setPointerCapture(e.pointerId); };
      var move = function (e) { if (startY === null) return; dy = Math.max(0, e.clientY - startY); var s = sheet(); if (s) { s.style.transition = 'none'; s.style.transform = 'translateY(' + dy + 'px)'; } };
      var up = function () {
        if (startY === null) return; startY = null; var s = sheet(); if (!s) return;
        s.style.transition = 'transform .22s ease';
        if (dy > 110) { s.style.transform = 'translateY(100%)'; setTimeout(function () { s.style.transform = ''; s.style.transition = ''; o.onClose(); }, 200); }
        else { s.style.transform = ''; }
      };
      [root.querySelector('.ntc__grab'), head].forEach(function (h) { if (!h) return; h.addEventListener('pointerdown', down); h.addEventListener('pointermove', move); h.addEventListener('pointerup', up); h.addEventListener('pointercancel', up); });
    }
    root.setAttribute('data-ntc-title-id', title.id);
    return root;
  }

  window.NavimowTerms = { build: build };
})();
